<div class="step-layout !mx-auto !flex !w-full !flex-col !gap-8">
    <header class="!flex !flex-col !gap-2">
        <p class="!mb-0 !text-xs !font-bold !uppercase !tracking-[0.08em] !text-primary">Passo 6 di 8</p>
        <h2 class="!mb-0 !text-[clamp(1.75rem,3vw,2.25rem)] !font-extrabold !leading-tight !text-strong">
            Termini e <span class="gradient-text">condizioni</span>
        </h2>
        <p class="!mb-0 !max-w-xl !text-base !leading-relaxed !text-subtle">
            Leggi i documenti e conferma le tre accettazioni richieste per creare l'account.
        </p>
    </header>

    <section class="!overflow-visible !rounded-2xl !border !border-solid !border-border !bg-white !p-6 md:!p-8"
             aria-labelledby="legal-consents-title">
        <div class="!mb-6 !flex !flex-col !gap-4 !border-b !border-solid !border-slate-100 !pb-5 sm:!flex-row sm:!items-center sm:!justify-between">
            <div>
                <h3 id="legal-consents-title" class="!mb-1 !text-base !font-bold !text-strong">Consensi richiesti</h3>
                <p class="!mb-0 !text-sm !leading-snug !text-subtle">Tutti i consensi sono obbligatori.</p>
            </div>
            <div class="!inline-flex !w-fit !items-center !gap-2 !rounded-full !px-3 !py-1.5 !text-sm !font-bold"
                 [ngClass]="allTermsAccepted ? '!bg-emerald-50 !text-emerald-700' : '!bg-slate-100 !text-slate-600'">
                <i class="bi" [ngClass]="allTermsAccepted ? 'bi-check-circle-fill' : 'bi-circle-half'" aria-hidden="true"></i>
                {{ acceptedTermsCount }} di 3 accettati
            </div>
        </div>

        <div class="!flex !flex-col !gap-4">
            <article class="!flex !cursor-pointer !gap-4 !rounded-2xl !border !border-solid !p-4 !transition-colors sm:!p-5"
                     [ngClass]="consentCardClass(companyTermsAndCondition1)"
                     (click)="onTermChange(1, !companyTermsAndCondition1)">
                <span class="consent-check" [class.consent-check--on]="companyTermsAndCondition1" aria-hidden="true">
                    <i class="bi bi-check-lg" *ngIf="companyTermsAndCondition1"></i>
                </span>
                <input class="consent-check-input" type="checkbox" id="company-termsandconditions1"
                       [ngModel]="companyTermsAndCondition1"
                       (click)="$event.stopPropagation()"
                       (ngModelChange)="onTermChange(1, $event)">
                <div class="!min-w-0 !flex-1">
                    <label for="company-termsandconditions1" class="!mb-0 !block !cursor-pointer !text-sm !font-semibold !leading-relaxed !text-slate-800"
                           (click)="$event.preventDefault()">
                        Accetto i Termini e condizioni d'uso del servizio.
                    </label>
                    <a href="assets/pdf/terms.pdf" target="_blank" rel="noopener"
                       class="!mt-2 !inline-flex !items-center !gap-1.5 !text-sm !font-bold !text-primary !no-underline hover:!underline"
                       (click)="$event.stopPropagation()">
                        <i class="bi bi-file-earmark-text" aria-hidden="true"></i>
                        Leggi i termini del servizio
                        <i class="bi bi-box-arrow-up-right !text-xs" aria-hidden="true"></i>
                    </a>
                </div>
            </article>

            <article class="!flex !cursor-pointer !gap-4 !rounded-2xl !border !border-solid !p-4 !transition-colors sm:!p-5"
                     [ngClass]="consentCardClass(companyTermsAndCondition2)"
                     (click)="onTermChange(2, !companyTermsAndCondition2)">
                <span class="consent-check" [class.consent-check--on]="companyTermsAndCondition2" aria-hidden="true">
                    <i class="bi bi-check-lg" *ngIf="companyTermsAndCondition2"></i>
                </span>
                <input class="consent-check-input" type="checkbox" id="company-termsandconditions2"
                       [ngModel]="companyTermsAndCondition2"
                       (click)="$event.stopPropagation()"
                       (ngModelChange)="onTermChange(2, $event)">
                <div class="!min-w-0 !flex-1">
                    <label for="company-termsandconditions2" class="!mb-0 !block !cursor-pointer !text-sm !font-semibold !leading-relaxed !text-slate-800"
                           (click)="$event.preventDefault()">
                        Accetto l'informativa per il trattamento dei dati personali.
                    </label>
                    <a href="assets/pdf/privacy.pdf" target="_blank" rel="noopener"
                       class="!mt-2 !inline-flex !items-center !gap-1.5 !text-sm !font-bold !text-primary !no-underline hover:!underline"
                       (click)="$event.stopPropagation()">
                        <i class="bi bi-shield-check" aria-hidden="true"></i>
                        Leggi l'informativa privacy
                        <i class="bi bi-box-arrow-up-right !text-xs" aria-hidden="true"></i>
                    </a>
                </div>
            </article>

            <article class="!flex !cursor-pointer !gap-4 !rounded-2xl !border !border-solid !p-4 !transition-colors sm:!p-5"
                     [ngClass]="consentCardClass(companyTermsAndCondition3)"
                     (click)="onTermChange(3, !companyTermsAndCondition3)">
                <span class="consent-check" [class.consent-check--on]="companyTermsAndCondition3" aria-hidden="true">
                    <i class="bi bi-check-lg" *ngIf="companyTermsAndCondition3"></i>
                </span>
                <input class="consent-check-input" type="checkbox" id="company-termsandconditions3"
                       [ngModel]="companyTermsAndCondition3"
                       (click)="$event.stopPropagation()"
                       (ngModelChange)="onTermChange(3, $event)">
                <div class="!min-w-0 !flex-1">
                    <label for="company-termsandconditions3" class="!mb-0 !block !cursor-pointer !text-sm !font-semibold !leading-relaxed !text-slate-800"
                           (click)="$event.preventDefault()">
                        Approvo espressamente le clausole specifiche, la durata e il rinnovo automatico ai sensi degli artt. 1341 e 1342 C.C.
                    </label>
                    <details class="!mt-3 !rounded-xl !bg-white/80 !px-4 !py-3" (click)="$event.stopPropagation()">
                        <summary class="!cursor-pointer !text-sm !font-bold !text-primary">Mostra il dettaglio delle clausole</summary>
                        <div class="!mt-3 !space-y-3 !text-sm !leading-relaxed !text-slate-600">
                            <p class="!mb-0">
                                Art. 3, servizi, condizioni e modalità di pagamento, comma 7; Art. 5, modalità utilizzo account, comma 3;
                                Art. 12, esclusione di responsabilità, commi 3, 4, 5 e 6; Art. 16, foro delle controversie e legge applicabile.
                            </p>
                            <p class="!mb-0"><strong class="!text-slate-800">Durata:</strong> 2 anni a partire dalla firma.</p>
                            <p class="!mb-0">
                                <strong class="!text-slate-800">Disdetta e rinnovo:</strong> la disdetta deve essere comunicata almeno 45 giorni prima della scadenza tramite PEC o raccomandata A/R. In assenza di comunicazione, il contratto si rinnova automaticamente per altri 2 anni.
                            </p>
                        </div>
                    </details>
                </div>
            </article>
        </div>
    </section>

    <div class="step-actions">
        <button type="button" class="btn-back" (click)="!isProcessing && previousStep()"
                [class.btn-back--disabled]="isProcessing">Indietro</button>
        <div class="step-actions-end">
            <p class="!mb-0 !w-full !text-right !text-sm !text-red-700"
               *ngIf="submitted && !allTermsAccepted">Devi accettare tutti i consensi per continuare.</p>
            <button type="button" class="btn-procedi" [disabled]="isProcessing" (click)="tryContinue()">
                <span *ngIf="isProcessing" class="spinner-border spinner-border-sm me-2" role="status"></span>
                {{ isProcessing ? 'Salvataggio...' : 'Accetta e procedi' }}
            </button>
        </div>
    </div>
</div>
